export default __webpack_public_path__ + "static/media/Head_2_Ear_3_C3.fb4bfebd.svg";